// extracted by mini-css-extract-plugin
export default {"header":"MainNavigation_header__SSZsE","nav":"MainNavigation_nav__uCK4O","navlist":"MainNavigation_navlist__kVDbh","navitem":"MainNavigation_navitem__FaMTm"};